<router-outlet></router-outlet>
<div id="c11n-icon-sticker-sheet" style="display: none;">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1000 1000"
    width="1000"
    height="1000"
  >
    <symbol id="accordion-closed-small" viewBox="0 0 14 14">
      <use
        xlink:href="#accordion-open-small"
        transform="rotate(180 7 7)"
      ></use>
    </symbol>
    <symbol id="accordion-open-small" viewBox="0 0 14 14">
      <g transform="matrix(1.4,0,0,1.4,0,0)">
        <path
          d="M5,0a5,5,0,1,0,5,5A5.006,5.006,0,0,0,5,0ZM7.53,6.28a.748.748,0,0,1-1.06,0L5.177,4.987a.252.252,0,0,0-.354,0L3.53,6.28A.75.75,0,0,1,2.47,5.22l2-2a.749.749,0,0,1,1.06,0l2,2A.749.749,0,0,1,7.53,6.28Z"
        ></path>
      </g>
    </symbol>
    <symbol id="accordion-closed-caret-small" viewBox="0 0 14 14">
      <polyline points="4 6 7 9 10 6"></polyline>
    </symbol>
    <symbol id="accordion-open-caret-small" viewBox="0 0 14 14">
      <use
        xlink:href="#accordion-closed-caret-small"
        transform="rotate(180 7 7)"
      ></use>
    </symbol>
    <symbol id="announcement-small" viewBox="0 0 14 14">
      <path
        d="M14,1.241A1,1,0,0,0,12.674.3L1.011,4.3A1.492,1.492,0,0,0,0,5.712V6.778a1.492,1.492,0,0,0,1.011,1.41l.547.188A.245.245,0,0,1,1.7,8.5a.253.253,0,0,1,.012.191A3.828,3.828,0,0,0,1.5,9.957a3.745,3.745,0,0,0,6.509,2.579,3.806,3.806,0,0,0,.811-1.4.25.25,0,0,1,.319-.16l3.535,1.213a.988.988,0,0,0,.326.055,1,1,0,0,0,1-1ZM6.534,11.186a1.718,1.718,0,0,1-1.28.569A1.779,1.779,0,0,1,3.5,9.957a1.848,1.848,0,0,1,.106-.617.251.251,0,0,1,.317-.153l2.853.979a.25.25,0,0,1,.159.306A1.805,1.805,0,0,1,6.534,11.186Z"
      ></path>
    </symbol>
    <symbol id="announcement-medium" viewBox="0 0 24 24">
      <path d="M0.5 8.999L0.5 13.999"></path>
      <path d="M23.5 1.999L23.5 20.999"></path>
      <path d="M0.5 9.999L23.5 2.999"></path>
      <path d="M0.5 12.999L23.5 19.999"></path>
      <path d="M5.5,14.521V17.1a3.5,3.5,0,1,0,7-.032v-.413"></path>
    </symbol>
    <symbol id="bank-medium" viewBox="0 0 24 24">
      <path
        d="M2.5 19.5v-8M1.5 19.5h5M.5 23.5h23M.5 21.5h23M1.5 11.5h5M9.5 19.5h5M9.5 11.5h5M5.5 19.5v-8M10.5 19.5v-8M13.5 19.5v-8M17.5 19.5h5M17.5 11.5h5M18.5 19.5v-8M21.5 19.5v-8M1.646 8.605a.5.5 0 0 0 .307.895h20.1a.5.5 0 0 0 .309-.894L12.339.741a.5.5 0 0 0-.616 0L1.646 8.605z"
      ></path>
    </symbol>
    <symbol id="bookmark-checked-small" viewBox="0 0 14 14">
      <path
        d="M4 0C3.60218 0 3.22064 0.158035 2.93934 0.43934C2.65804 0.720644 2.5 1.10218 2.5 1.5V13.5C2.5 13.7022 2.62182 13.8845 2.80866 13.9619C2.9955 14.0393 3.21055 13.9966 3.35355 13.8536L7 10.2071L10.6464 13.8536C10.7894 13.9966 11.0045 14.0393 11.1913 13.9619C11.3782 13.8845 11.5 13.7022 11.5 13.5V1.5C11.5 1.10217 11.342 0.720644 11.0607 0.43934C10.7794 0.158035 10.3978 0 10 0H4Z"
      ></path>
    </symbol>
    <symbol id="bookmark-unchecked-small" viewBox="0 0 14 14">
      <path
        d="M3.95209,.00589c-.45463,.04066-.8801,.26904-1.16673,.62626-.18726,.23338-.30534,.50379-.3561,.81544l-.01277,.0784-.00176,5.894c-.00131,4.37873-.00012,5.90696,.0046,5.9444,.03877,.30693,.26896,.55878,.56827,.62178,.02464,.00519,.08008,.01071,.1232,.01227,.16995,.00616,.31049-.03515,.448-.13168,.03406-.02391,.45191-.43827,1.743-1.72844l1.6982-1.69699,1.6982,1.69733c1.54088,1.5401,1.7031,1.70056,1.7511,1.73223,.14405,.09502,.27684,.13354,.4399,.12758,.1192-.00435,.20424-.02569,.30192-.07577,.15334-.07861,.28952-.22933,.35012-.3875,.01711-.04467,.0321-.10752,.03941-.1652,.00475-.03751,.00593-1.55885,.00462-5.9472l-.00177-5.8968-.01277-.0784c-.06135-.37666-.22094-.69344-.47972-.95222-.25911-.25912-.57542-.41846-.95222-.47968l-.0784-.01274-3.0296-.00073c-1.66628-.0004-3.0517,.00125-3.07871,.00366m.07991,1.45501c-.07579,.02435-.13399,.08314-.15779,.1594-.00984,.03153-.01021,.20835-.01021,4.96712v4.93442l1.3314-1.33036c.85666-.85599,1.34591-1.3409,1.37208-1.35991,.08724-.06336,.16805-.10131,.26541-.12464,.04537-.01088,.06754-.01254,.16711-.01254s.12174,.00166,.16711,.01254c.09736,.02333,.17817,.06129,.26541,.12464,.02617,.01901,.51542,.50392,1.37208,1.35991l1.3314,1.33036V6.58741c0-4.75877-.00036-4.93558-.01021-4.96712-.0241-.0772-.08249-.13559-.15969-.15969-.03147-.00982-.14307-.0102-2.968-.00991-2.79067,.00029-2.93682,.00079-2.9661,.0102"
      />
    </symbol>
    <symbol id="caret-down-small" viewBox="0 0 14 14">
      <use xlink:href="#caret-up-small" transform="rotate(180 7 7)"></use>
    </symbol>
    <symbol id="caret-down-medium" viewBox="0 0 24 24">
      <use
        xlink:href="#caret-up-medium"
        transform="rotate(180 12 12)"
      ></use>
    </symbol>
    <symbol id="caret-left-small" viewBox="0 0 14 14">
      <use xlink:href="#caret-up-small" transform="rotate(270 7 7)"></use>
    </symbol>
    <symbol id="caret-right-small" viewBox="0 0 14 14">
      <use xlink:href="#caret-up-small" transform="rotate(90 7 7)"></use>
    </symbol>
    <symbol id="caret-up-small" viewBox="0 0 14 14">
      <g transform="matrix(1.4,0,0,1.4,0,0)">
        <path
          d="M9.794,6.607,5.884,2.49A1.255,1.255,0,0,0,4.1,2.5l-3.9,4.1A.75.75,0,1,0,1.294,7.641L4.819,3.928a.249.249,0,0,1,.362,0L8.706,7.641A.75.75,0,1,0,9.794,6.607Z"
        ></path>
      </g>
    </symbol>
    <symbol id="caret-up-medium" viewBox="0 0 24 24">
      <path
        d="M23.535,18.373,12.409,5.8a.5.5,0,0,0-.749,0L.535,18.373"
      ></path>
    </symbol>
    <symbol id="caret-left-double-small" viewBox="0 0 14 14">
      <path
        d="M7.49668 12.2885C7.88706 12.679 7.88706 13.312 7.49668 13.7025C7.10653 14.0909 6.47583 14.0909 6.08568 13.7025L0.43968 8.05652C0.158168 7.77519 0 7.39351 0 6.99552C0 6.59753 0.158168 6.21585 0.43968 5.93452L6.08568 0.288522C6.48115 -0.0690536 7.08761 -0.0534809 7.46421 0.32392C7.84081 0.70132 7.85509 1.30781 7.49668 1.70252L2.38368 6.81852C2.33666 6.86542 2.31023 6.92911 2.31023 6.99552C2.31023 7.06193 2.33666 7.12562 2.38368 7.17252L7.49668 12.2885ZM13.4967 12.2885C13.8871 12.679 13.8871 13.312 13.4967 13.7025C13.1065 14.0909 12.4758 14.0909 12.0857 13.7025L6.43968 8.05652C6.15817 7.77519 6 7.39351 6 6.99552C6 6.59753 6.15817 6.21585 6.43968 5.93452L12.0857 0.288522C12.4812 -0.0690536 13.0876 -0.0534809 13.4642 0.32392C13.8408 0.70132 13.8551 1.30781 13.4967 1.70252L8.38368 6.81852C8.33666 6.86542 8.31023 6.92911 8.31023 6.99552C8.31023 7.06193 8.33666 7.12562 8.38368 7.17252L13.4967 12.2885Z"
      />
    </symbol>
    <symbol id="chat-small" viewBox="0 0 14 14">
      <path
        d="M7,0A7,7,0,0,0,0,7a6.89,6.89,0,0,0,1,3.55.25.25,0,0,1,0,.22L0,13.32a.51.51,0,0,0,.09.5A.46.46,0,0,0,.5,14H.59L4,13.37a.22.22,0,0,1,.14,0A7,7,0,1,0,7,0ZM3.25,8.25A1.25,1.25,0,1,1,4.5,7,1.25,1.25,0,0,1,3.25,8.25ZM7,8.25A1.25,1.25,0,1,1,8.25,7,1.25,1.25,0,0,1,7,8.25Zm3.75,0A1.25,1.25,0,1,1,12,7,1.25,1.25,0,0,1,10.75,8.25Z"
      ></path>
    </symbol>
    <symbol id="chat-internal-medium" viewBox="0 0 24 24">
      <path d="M2.5,14.75a2,2,0,0,1,0-4"></path>
      <path d="M14.5,21.75h2c1.934,0,3.5-1.066,3.5-3V17.685"></path>
      <path
        d="M11.500 21.750 A1.500 1.500 0 1 0 14.500 21.750 A1.500 1.500 0 1 0 11.500 21.750 Z"
      ></path>
      <path d="M6.5,17.75h-2a2,2,0,0,1-2-2v-6a2,2,0,0,1,2-2h2Z"></path>
      <path d="M21.5,14.75a2,2,0,0,0,0-4"></path>
      <path d="M17.5,17.75h2a2,2,0,0,0,2-2v-6a2,2,0,0,0-2-2h-2Z"></path>
      <path d="M5,7.75a7,7,0,0,1,14,0"></path>
    </symbol>
    <symbol id="chat-internal-fill-medium" viewBox="0 0 24 24">
      <path
        d="m20,8.05023v-.05023C20,3.58887,16.41113,0,12,0S4,3.58887,4,8v.04852c-1.01099.11145-1.95203.53809-2.68262,1.2674C.4668,10.16504-.00195,11.29492-.00293,12.49658c-.00098,1.90576,1.20557,3.61279,3.00244,4.24756.16504.05762.33301.08496.49854.08496.61816,0,1.19824-.38379,1.41504-.99805.05762-.16016.08691-.3291.08691-.50098v-7.33008c0-3.85986,3.14014-7,7-7,3.85938,0,7,3.14014,7,7v7.33008c0,.17188.0293.34082.08594.5.15717.44122.50385.7572.91406.90405v1.76587c0,1.8457-1.61621,2.5-3,2.5h-.5c0-.55176-.44824-1-1-1h-4c-.82715,0-1.5.67285-1.5,1.5s.67285,1.5,1.5,1.5h4c.55176,0,1-.44824,1-1h.5c2.39258,0,4-1.40625,4-3.5v-1.75568c.00031-.00012.00067-.00006.00098-.00018,1.79688-.63477,3.00293-2.3418,3.00195-4.24756-.00183-2.30975-1.7594-4.19531-4.00293-4.44635Z"
      />
    </symbol>
    <symbol id="chat-internal-small" viewBox="0 0 14 14">
      <g
        transform="matrix(0.9,0,0,0.9,0.7000000000000002,0.6999999995741968)"
      >
        <path
          d="M6.98656 1.50051C6.56826 1.49301 6.15261 1.56812 5.76339 1.72154C5.37418 1.87496 5.01907 2.10367 4.7184 2.39457C4.41773 2.68547 4.17741 3.03283 4.01122 3.41677C3.84574 3.79906 3.757 4.21012 3.75 4.6266V5V7.25063V9C3.75 9.55228 3.30228 10 2.75 10H1.5C0.671573 10 0 9.32843 0 8.5V6.5C0 5.67157 0.671573 5 1.5 5H2.25V4.62063V4.6093L2.25009 4.6093C2.25939 3.99368 2.39007 3.38593 2.63465 2.8209C2.87923 2.25587 3.23291 1.74465 3.6754 1.31654C4.11789 0.888422 4.64052 0.551829 5.21332 0.326043C5.78195 0.101901 6.38894 -0.0086692 7 0.000530303C7.61106 -0.0086692 8.21805 0.101901 8.78668 0.326043C9.35948 0.551829 9.88211 0.888422 10.3246 1.31654C10.7671 1.74465 11.1208 2.25587 11.3653 2.8209C11.6099 3.38593 11.7406 3.99368 11.7499 4.6093L11.7501 4.62063H11.75V5H12.5C13.3284 5 14 5.67157 14 6.5V8.5C14 9.32843 13.3284 10 12.5 10H11.75V10.5C11.75 11.2293 11.4603 11.9288 10.9445 12.4445C10.5022 12.8868 9.92479 13.1629 9.30926 13.2326C9.05247 13.6905 8.56238 14 8 14H6.5C5.67157 14 5 13.3284 5 12.5C5 11.6716 5.67157 11 6.5 11H8C8.54196 11 9.01679 11.2874 9.28038 11.7182C9.50711 11.666 9.71673 11.551 9.88388 11.3839C10.1183 11.1495 10.25 10.8315 10.25 10.5V4.62661C10.243 4.21013 10.1543 3.79906 9.98878 3.41677C9.82259 3.03283 9.58227 2.68547 9.2816 2.39457C8.98093 2.10367 8.62582 1.87496 8.23661 1.72154C7.84739 1.56812 7.43174 1.49301 7.01344 1.50051C7.00448 1.50067 6.99552 1.50067 6.98656 1.50051Z"
        ></path>
      </g>
    </symbol>
    <symbol id="check-small" viewBox="0 0 14 14">
      <path
        d="M10.715,3.912 C10.8713243,4.03506505 10.9721806,4.21533706 10.9952631,4.41294647 C11.0183457,4.61055588 10.9617526,4.80921943 10.838,4.965 L6.906,9.933 C6.71308373,10.227772 6.40465388,10.4273661 6.05672119,10.4825935 C5.70878851,10.5378209 5.35371265,10.4435452 5.079,10.223 L3.292,8.844 C2.96394286,8.59105358 2.90305358,8.12005714 3.156,7.792 C3.40894642,7.46394286 3.87994286,7.40305358 4.208,7.656 L5.618,8.745 C5.72713228,8.82771009 5.88241757,8.80768763 5.967,8.7 L9.667,4.033 C9.92357005,3.7112448 10.3918594,3.65717705 10.715,3.912 Z"
      ></path>
    </symbol>
    <symbol id="check-medium" viewBox="0 0 24 24">
      <path d="M18 6.999L11 16.499 6 12.499"></path>
    </symbol>
    <symbol id="closed-captions-small" viewBox="0 0 14 14">
      <path
        d="M12.5,1 C13.2796961,1 13.9204487,1.59488808 13.9931334,2.35553999 L14,2.5 L14,11.5 C14,12.2796961 13.4051119,12.9204487 12.64446,12.9931334 L12.5,13 L1.5,13 C0.720303883,13 0.0795513218,12.4051119 0.00686657806,11.64446 L0,11.5 L0,2.5 C0,1.72030388 0.594888083,1.07955132 1.35553999,1.00686658 L1.5,1 L12.5,1 Z M5.5,3.5 C3.30649844,3.5 1.5,5.04842723 1.5,7 C1.5,8.95157277 3.30649844,10.5 5.5,10.5 C5.77614237,10.5 6,10.2761424 6,10 C6,9.72385763 5.77614237,9.5 5.5,9.5 C3.82750832,9.5 2.5,8.36213573 2.5,7 C2.5,5.63786427 3.82750832,4.5 5.5,4.5 C5.77614237,4.5 6,4.27614237 6,4 C6,3.72385763 5.77614237,3.5 5.5,3.5 Z M12,3.5 C9.80649844,3.5 8,5.04842723 8,7 C8,8.95157277 9.80649844,10.5 12,10.5 C12.2761424,10.5 12.5,10.2761424 12.5,10 C12.5,9.72385763 12.2761424,9.5 12,9.5 C10.3275083,9.5 9,8.36213573 9,7 C9,5.63786427 10.3275083,4.5 12,4.5 C12.2761424,4.5 12.5,4.27614237 12.5,4 C12.5,3.72385763 12.2761424,3.5 12,3.5 Z"
      ></path>
    </symbol>
    <symbol id="copy-small" viewBox="0 0 14 14">
      <path
        d="M11.2,14 L5.8,14 C4.8,14 4.1,13.2 4,12.2 L4,4.8 C4,3.8 4.8,3 5.8,3 L9.6,3 C9.7,3 9.9,3.1 10,3.2 L12.8,6 C12.9,6.1 13,6.3 13,6.5 L13,12.3 C13,13.2 12.2,14 11.2,14 Z M5.8,4.5 C5.7,4.5 5.6,4.6 5.6,4.7 L5.6,12.2 C5.6,12.3 5.7,12.4 5.8,12.4 L11.3,12.4 C11.4,12.4 11.5,12.3 11.5,12.2 L11.5,6.9 C11.5,6.8 11.5,6.8 11.4,6.7 L9.3,4.6 C9.3,4.6 9.2,4.5 9.1,4.5 L5.8,4.5 Z M7.5,0.8 C7.5,1.2 7.2,1.6 6.7,1.6 L2.7,1.6 C2.6,1.6 2.5,1.7 2.5,1.8 L2.5,9.8 C2.5,10.2 2.2,10.6 1.7,10.6 C1.2,10.6 1,10.2 1,9.8 L1,1.8 C1,0.8 1.8,0 2.8,0 L6.8,0 C7.2,0 7.5,0.3 7.5,0.8 Z"
      ></path>
    </symbol>
    <symbol id="date-picker-small" viewBox="0 0 14 14">
      <path
        d="M12.25,1.5h-1.5V.75a.75.75,0,0,0-1.5,0V1.5H4.75V.75a.75.75,0,0,0-1.5,0V1.5H1.75A1.752,1.752,0,0,0,0,3.25v9A1.752,1.752,0,0,0,1.75,14h10.5A1.752,1.752,0,0,0,14,12.25v-9A1.752,1.752,0,0,0,12.25,1.5ZM1.5,3.25A.25.25,0,0,1,1.75,3h1.5v.75a.75.75,0,0,0,1.5,0V3h4.5v.75a.75.75,0,0,0,1.5,0V3h1.5a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H1.75a.25.25,0,0,1-.25-.25Z"
      ></path>
    </symbol>
    <symbol id="date-picker-medium" viewBox="0 0 24 24">
      <path
        d="M0.500 2.501 L23.500 2.501 L23.500 23.501 L0.500 23.501 Z"
      ></path>
      <path d="M5.5 0.501L5.5 5.501"></path>
      <path d="M18.5 0.501L18.5 5.501"></path>
      <path d="M0.5 7.501L23.5 7.501"></path>
    </symbol>
    <symbol id="delete-small" viewBox="0 0 14 14">
      <path
        d="M7,0a7,7,0,1,0,7,7A7.008,7.008,0,0,0,7,0ZM9.651,8.591a.75.75,0,0,1-1.06,1.061L7,8.061,5.409,9.652a.75.75,0,1,1-1.06-1.061L5.94,7,4.349,5.409a.75.75,0,1,1,1.06-1.061L7,5.939,8.591,4.348a.75.75,0,0,1,1.06,1.061L8.06,7Z"
      ></path>
    </symbol>
    <symbol id="disallowed-small" viewBox="0 0 14 14">
      <g>
        <path
          d="M4.24261 2.8284C5.03304 2.30488 5.98092 2 7 2c2.76142 0 5 2.23858 5 5 0 1.01908 -0.3049 1.96696 -0.8284 2.75739L4.24261 2.8284ZM2.8284 4.24261l6.92899 6.92899C8.96696 11.6951 8.01908 12 7 12c-2.76142 0 -5 -2.23858 -5 -5 0 -1.01908 0.30488 -1.96696 0.8284 -2.75739ZM7 0C3.13401 0 0 3.13401 0 7c0 3.866 3.13401 7 7 7 3.866 0 7 -3.134 7 -7 0 -3.86599 -3.134 -7 -7 -7Z"
        ></path>
      </g>
    </symbol>
    <symbol id="disallowed-medium" viewBox="0 0 24 24">
      <path d="M0.5 12a11.5 11.5 0 1 0 23 0 11.5 11.5 0 1 0 -23 0Z"></path>
      <path d="m3.868 3.868 16.264 16.264"></path>
    </symbol>
    <symbol id="document-small" viewBox="0 0 14 14">
      <path
        d="M12.707,4.293l-4-4A1,1,0,0,0,8,0H3A2,2,0,0,0,1,2V12a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V5A1,1,0,0,0,12.707,4.293ZM3.25,12A.25.25,0,0,1,3,11.75V2.25A.25.25,0,0,1,3.25,2h3.5A.25.25,0,0,1,7,2.25V5A1,1,0,0,0,8,6h2.75a.25.25,0,0,1,.25.25v5.5a.25.25,0,0,1-.25.25Z"
      ></path>
    </symbol>
    <symbol id="document-medium" viewBox="0 0 24 24">
      <g transform="translate(2)">
        <path
          d="M19.207,4.5 C19.3945494,4.68749273 19.5,4.94180519 19.5,5.207 L19.5,22.5 C19.5,23.0522847 19.0522847,23.5 18.5,23.5 L1.5,23.5 C0.94771525,23.5 0.5,23.0522847 0.5,22.5 L0.5,1.5 C0.5,0.94771525 0.94771525,0.5 1.5,0.5 L14.793,0.5 C15.0581948,0.5 15.3125073,0.605450625 15.5,0.793 L19.207,4.5 Z"
        ></path>
        <line x1="4" y1="16" x2="16" y2="16"></line>
        <line x1="4" y1="19" x2="16" y2="19"></line>
        <line x1="4" y1="13" x2="16" y2="13"></line>
        <line x1="4" y1="10" x2="16" y2="10"></line>
        <line x1="4" y1="7" x2="11" y2="7"></line>
        <line x1="4" y1="7" x2="11" y2="7"></line>
        <line x1="4" y1="10" x2="16" y2="10"></line>
        <line x1="4" y1="13" x2="16" y2="13"></line>
        <line x1="4" y1="16" x2="16" y2="16"></line>
        <line x1="4" y1="19" x2="16" y2="19"></line>
      </g>
    </symbol>
    <symbol id="document-pdf-medium" viewBox="0 0 24 24">
      <path
        d="M20.5,23.5a1,1,0,0,0,1-1V6.473A5.975,5.975,0,0,0,15.525.5H3.5a1,1,0,0,0-1,1v21a1,1,0,0,0,1,1Z"
      ></path>
      <path d="M16.5.579V4.5a1,1,0,0,0,1,1h3.92"></path>
      <path
        d="M8.479,15a1.5,1.5,0,0,1-1.5,1.5h-1.5v-3h1.5A1.5,1.5,0,0,1,8.479,15Z"
      ></path>
      <path d="M5.479 19.499L5.479 16.499"></path>
      <path d="M10.479,13.5a3,3,0,1,1,0,6Z"></path>
      <path d="M15.479,19.5v-5a1,1,0,0,1,1-1h2"></path>
      <path d="M15.479 16.499L17.479 16.499"></path>
    </symbol>
    <symbol id="download-small" viewBox="0 0 14 14">
      <path
        d="M10.03 5.22a.749.749 0 0 0-1.06 0L7.75 6.439V.75a.75.75 0 0 0-1.5 0v5.689L5.03 5.22a.75.75 0 1 0-1.06 1.06l2.5 2.5a.749.749 0 0 0 1.06 0l2.5-2.5a.749.749 0 0 0 0-1.06zM13 9.5a1 1 0 0 0-1 1v1.25a.25.25 0 0 1-.25.25h-9.5a.25.25 0 0 1-.25-.25V10.5a1 1 0 0 0-2 0V12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1.5a1 1 0 0 0-1-1z"
      ></path>
    </symbol>
    <symbol id="download-medium" viewBox="0 0 24 24">
      <path
        d="M23,18.218v1.913A2.87,2.87,0,0,1,20.131,23H3.869A2.869,2.869,0,0,1,1,20.131V18.218"
      ></path>
      <path d="M12 18.108L12 1"></path>
      <path d="M19 11.108L12 18.108 5 11.108"></path>
    </symbol>
    <symbol id="edit-small" viewBox="0 0 14 14">
      <path
        d="M11.75,12.493H.75a.75.75,0,0,0,0,1.5h11a.75.75,0,0,0,0-1.5Z"
      ></path>
      <path
        d="M13.561,1.493,12.5.432a1.537,1.537,0,0,0-2.121,0L3.671,7.139a.5.5,0,0,0-.138.267L3,10.411A.5.5,0,0,0,3.5,11a.433.433,0,0,0,.087-.008l3.005-.53a.5.5,0,0,0,.267-.139l6.707-6.707a1.5,1.5,0,0,0,0-2.121Z"
      ></path>
    </symbol>
    <symbol id="edit-list-small" viewBox="0 0 14 14">
      <path
        d="M2.99997,1C2.99997,.44772,3.44769,0,3.99997,0h3C7.55226,0,7.99997,.44772,7.99997,1v.5c0,.55229-.44771,1-1,1H3.99997c-.55228,0-1-.44771-1-1v-.5Z"
      />
      <path
        d="M11.9105,7c.1185-.00006,.2321,.04698,.3159,.13076l1.6428,1.64285c.1744,.17434,.1744,.45701,0,.63135l-4.20532,4.20534c-.06901,.069-.15874,.1135-.25544,.1267l-1.90179,.2589c-.13857,.0189-.27797-.0283-.37662-.1274-.09866-.0991-.14517-.2387-.12567-.3772l.26786-1.9018c.01349-.0958,.05773-.1846,.12605-.2531l4.19643-4.20531c.0837-.08387,.1973-.13103,.3158-.13109Z"
      />
      <path
        d="M5.75854,13.66699c-.01001-.11597-.00854-.23322,.00806-.3504l.23871-1.6911H3c-.34521,0-.625-.27979-.625-.625s.27979-.625,.625-.625h3.59131l1.24713-1.25H3c-.34521,0-.625-.27985-.625-.625s.27979-.625,.625-.625h5c.29694,0,.53387,.21149,.59753,.48914l1.72534-1.72931,.0127-.00989,.66443-.66541V2.5c0-.82843-.67151-1.5-1.5-1.5h-.25v.5c0,1.24261-1.00739,2.25-2.25,2.25h-3c-1.24268,0-2.25-1.00739-2.25-2.25v-.5h-.25c-.82843,0-1.5,.67157-1.5,1.5V12.5c0,.82843,.67157,1.5,1.5,1.5H5.81866c-.02985-.10901-.05237-.21954-.06012-.33301ZM3,5.37549h5c.34515,0,.625,.27985,.625,.625s-.27985,.625-.625,.625H3c-.34521,0-.625-.27985-.625-.625s.27979-.625,.625-.625Z"
      />
    </symbol>
    <symbol id="edit-user-action-small" viewBox="0 0 14 14">
      <circle cx="5" cy="3" r="3"></circle>
      <path
        d="M11.9105 7C12.029 6.99994 12.1426 7.04698 12.2264 7.13076L13.8692 8.77361C14.0436 8.94795 14.0436 9.23062 13.8692 9.40496L9.66388 13.6103C9.59487 13.6793 9.50514 13.7238 9.40844 13.737L7.50665 13.9959C7.36808 14.0148 7.22868 13.9676 7.13003 13.8685C7.03137 13.7694 6.98486 13.6298 7.00436 13.4913L7.27222 11.5895C7.28571 11.4937 7.32995 11.4049 7.39827 11.3364L11.5947 7.13109C11.6784 7.04722 11.792 7.00006 11.9105 7Z"
      ></path>
      <path
        d="M8.51685 8.44586C7.61355 7.55196 6.37123 6.99998 5 6.99998C2.23858 6.99998 0 9.23855 0 12C0 12.2761 0.223858 12.5 0.5 12.5H5.88167L6.03445 11.4152C6.08572 11.0512 6.25383 10.7137 6.51347 10.4535L8.51685 8.44586Z"
      ></path>
    </symbol>
    <symbol id="email-small" viewBox="0 0 14 14">
      <path
        d="M13.523.477A1.613,1.613,0,0,0,11.861.084L1.109,3.668A1.624,1.624,0,0,0,.475,6.357L3.063,8.946,2.976,12.2a.5.5,0,0,0,.73.458l2.017-1.049,1.92,1.92a1.634,1.634,0,0,0,1.52.433,1.614,1.614,0,0,0,1.169-1.067L13.916,2.138A1.616,1.616,0,0,0,13.523.477Zm-2.64,3.389L5.6,9.627A.347.347,0,0,1,5,9.392V7.274a1,1,0,0,1,.445-.832L10.31,3.2a.443.443,0,0,1,.573.668Z"
      ></path>
    </symbol>
    <symbol id="email-medium" viewBox="0 0 24 24">
      <path
        d="M0.500 3.954 L23.500 3.954 L23.500 19.954 L0.500 19.954 Z"
      ></path>
      <path d="M22.911 4.536L12 13.454 1.089 4.536"></path>
    </symbol>
    <symbol id="error-small" viewBox="0 0 14 14">
      <path
        d="M13.54,5.88,8.11.45a1.61,1.61,0,0,0-2.22,0L.46,5.88A1.55,1.55,0,0,0,0,7,1.53,1.53,0,0,0,.46,8.1l5.43,5.43a1.57,1.57,0,0,0,2.22,0L13.54,8.1A1.53,1.53,0,0,0,14,7,1.55,1.55,0,0,0,13.54,5.88ZM6.25,3.49a.75.75,0,0,1,1.5,0v3a.75.75,0,0,1-1.5,0Zm.75,7a1,1,0,1,1,1-1A1,1,0,0,1,7,10.49Z"
      ></path>
    </symbol>
    <symbol id="error-medium" viewBox="0 0 24 24">
      <path
        d="M4.199 4.307 L19.755 4.307 L19.755 19.863 L4.199 19.863 Z"
        transform="translate(-5.038 12.008) rotate(-45)"
      ></path>
      <path d="M12 14.11L12 7.11"></path>
      <path d="M11.996 16.11L11.996 16.11"></path>
      <path
        d="M11.987,16.11a.245.245,0,0,0-.237.255A.254.254,0,0,0,12,16.61h.009a.246.246,0,0,0,.237-.255A.253.253,0,0,0,12,16.11"
      ></path>
      <path d="M12,16.11h-.009"></path>
    </symbol>
    <symbol id="error-fill-medium" viewBox="0 0 24 24">
      <use xlink:href="#error-small"></use>
    </symbol>
    <symbol id="fast-forward-small" viewBox="0 0 14 14">
      <path
        d="M13.278,5.6,8.635,2.282A1.507,1.507,0,0,0,6.25,3.507V5.043L2.385,2.282A1.507,1.507,0,0,0,0,3.507v6.986a1.507,1.507,0,0,0,2.383,1.226L6.25,8.957v1.536a1.507,1.507,0,0,0,2.383,1.226L13.277,8.4a1.72,1.72,0,0,0,0-2.8Z"
      ></path>
    </symbol>
    <symbol id="feedback-dislike-medium" viewBox="0 0 24 24">
      <path
        d="M4.5,8h0a1.5,1.5,0,0,1,0-3h1a1.5,1.5,0,0,1,0-3H12c4,0,3,1.87,11,1.87V13H20a7.811,7.811,0,0,0-7.5,7.856c0,1.582-3,1.813-3-1.187A29.774,29.774,0,0,1,10.5,14h-8a1.5,1.5,0,0,1,0-3h1a1.5,1.5,0,0,1,0-3h1"
      ></path>
    </symbol>
    <symbol id="feedback-dislike-fill-medium" viewBox="0 0 24 24">
      <path
        d="M.25,12.44A2.25,2.25,0,0,0,2.5,14.69H9.23a.25.25,0,0,1,.19.09.23.23,0,0,1,.05.21,25.27,25.27,0,0,0-.72,4.73A3.36,3.36,0,0,0,9.51,22a2.36,2.36,0,0,0,1.74.79,1.89,1.89,0,0,0,2-1.87A7.19,7.19,0,0,1,20,13.69h3a.76.76,0,0,0,.75-.75v-9A.75.75,0,0,0,23,3.19c-4.53,0-6-.64-7.31-1.2A8.15,8.15,0,0,0,12,1.19H5.5A2.25,2.25,0,0,0,3.25,3.44a2.22,2.22,0,0,0,.23,1,2.25,2.25,0,0,0-1.23,2,2.22,2.22,0,0,0,.23,1,2.25,2.25,0,0,0-1.23,2,2.22,2.22,0,0,0,.23,1A2.25,2.25,0,0,0,.25,12.44Z"
      ></path>
    </symbol>
    <symbol id="feedback-like-medium" viewBox="0 0 24 24">
      <use
        xlink:href="#feedback-dislike-medium"
        transform="rotate(180 12 12)"
      ></use>
    </symbol>
    <symbol id="feedback-like-fill-medium" viewBox="0 0 24 24">
      <use
        xlink:href="#feedback-dislike-fill-medium"
        transform="rotate(180 12 12)"
      ></use>
    </symbol>
    <symbol id="feedback-dislike-small" viewBox="0 0 14 14">
      <path
        d="M.75.75A.76.76,0,0,0,0,1.5V8A.75.75,0,0,0,1.5,8V1.5A.76.76,0,0,0,.75.75Z"
      ></path>
      <path
        d="M11.31.78H3.75a.75.75,0,0,0,0,1.5h7.56a.39.39,0,0,1,.39.34l.8,4.67a.4.4,0,0,1-.1.31.38.38,0,0,1-.3.13H7.71A.75.75,0,0,0,7,8.48v2.91a.38.38,0,0,1-.67.19L4.36,8.92a.76.76,0,0,0-1.05-.16.75.75,0,0,0-.17,1.05l1.91,2.61a1.83,1.83,0,0,0,1.55.83,1.86,1.86,0,0,0,1.86-1.86V9.48a.25.25,0,0,1,.25-.25H12.1a1.89,1.89,0,0,0,1.44-.66A1.91,1.91,0,0,0,14,7.05l-.8-4.67A1.88,1.88,0,0,0,11.31.78Z"
      ></path>
    </symbol>
    <symbol id="feedback-dislike-fill-small" viewBox="0 0 14 14">
      <path
        d="M14,7.09A1.66,1.66,0,0,1,12.35,9H8.71a.25.25,0,0,0-.25.25v2.15A1.62,1.62,0,0,1,6.85,13a1.59,1.59,0,0,1-1.36-.75L3.17,8.62A.25.25,0,0,0,3,8.5H.5A.5.5,0,0,1,0,8V1.5A.5.5,0,0,1,.5,1H11.56a1.65,1.65,0,0,1,1.63,1.39Z"
      ></path>
    </symbol>
    <symbol id="feedback-like-small" viewBox="0 0 14 14">
      <path
        d="M.75,13.25A.76.76,0,0,1,0,12.5V6A.75.75,0,0,1,1.5,6v6.5A.76.76,0,0,1,.75,13.25Z"
      ></path>
      <path
        d="M11.31,13.22H3.75a.75.75,0,1,1,0-1.5h7.56a.39.39,0,0,0,.39-.34l.8-4.67a.4.4,0,0,0-.1-.31.38.38,0,0,0-.3-.13H7.71A.75.75,0,0,1,7,5.52V2.61a.38.38,0,0,0-.67-.19L4.36,5.08a.76.76,0,0,1-1.05.16.75.75,0,0,1-.17-1L5.05,1.58A1.83,1.83,0,0,1,6.6.75,1.86,1.86,0,0,1,8.46,2.61V4.52a.25.25,0,0,0,.25.25H12.1a1.89,1.89,0,0,1,1.44.66A1.91,1.91,0,0,1,14,7l-.8,4.67A1.88,1.88,0,0,1,11.31,13.22Z"
      ></path>
    </symbol>
    <symbol id="feedback-like-fill-small" viewBox="0 0 14 14">
      <path
        d="M14,6.91A1.66,1.66,0,0,0,12.35,5H8.71a.25.25,0,0,1-.25-.25V2.61A1.62,1.62,0,0,0,6.85,1a1.59,1.59,0,0,0-1.36.75L3.17,5.38A.25.25,0,0,1,3,5.5H.5A.5.5,0,0,0,0,6v6.5a.5.5,0,0,0,.5.5H11.56a1.65,1.65,0,0,0,1.63-1.39Z"
      ></path>
    </symbol>
    <symbol id="filter-small" viewBox="0 0 14 14">
      <path d="M13,3H1A1,1,0,0,1,1,1H13a1,1,0,0,1,0,2Z"></path>
      <path d="M12,8H2A1,1,0,0,1,2,6H12a1,1,0,0,1,0,2Z"></path>
      <path d="M10,13H4a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z"></path>
    </symbol>
    <symbol id="full-screen-small" viewBox="0 0 14 14">
      <path
        d="M1,5.5a1,1,0,0,1-1-1v-3A1.5,1.5,0,0,1,1.5,0h3a1,1,0,0,1,0,2H2.25A.25.25,0,0,0,2,2.25V4.5A1,1,0,0,1,1,5.5Z"
      ></path>
      <path
        d="M13,5.5a1,1,0,0,1-1-1V2.25A.25.25,0,0,0,11.75,2H9.5a1,1,0,0,1,0-2h3A1.5,1.5,0,0,1,14,1.5v3A1,1,0,0,1,13,5.5Z"
      ></path>
      <path
        d="M12.5,14h-3a1,1,0,0,1,0-2h2.25a.25.25,0,0,0,.25-.25V9.5a1,1,0,0,1,2,0v3A1.5,1.5,0,0,1,12.5,14Z"
      ></path>
      <path
        d="M4.5,14h-3A1.5,1.5,0,0,1,0,12.5v-3a1,1,0,0,1,2,0v2.25a.25.25,0,0,0,.25.25H4.5a1,1,0,0,1,0,2Z"
      ></path>
    </symbol>
    <symbol id="gifted-shares-small" viewBox="0 0 14 14">
      <path
        d="M12.5,9.75A.76.76,0,0,0,11.75,9H8a.25.25,0,0,0-.25.25v4.5A.25.25,0,0,0,8,14h3.75a.76.76,0,0,0,.75-.75Z"
      ></path>
      <path
        d="M6.25,9.25A.25.25,0,0,0,6,9H2.25a.76.76,0,0,0-.75.75v3.5a.76.76,0,0,0,.75.75H6a.25.25,0,0,0,.25-.25Z"
      ></path>
      <path
        d="M14,4.75A.76.76,0,0,0,13.25,4h-.58a.25.25,0,0,1-.22-.13.24.24,0,0,1,0-.26,2.4,2.4,0,0,0,.37-1.12A2.35,2.35,0,0,0,8.52,1.06l-1.31,2a.24.24,0,0,1-.42,0l-1.31-2A2.35,2.35,0,0,0,1.17,2.49a2.4,2.4,0,0,0,.37,1.12.27.27,0,0,1,0,.26A.25.25,0,0,1,1.33,4H.75A.76.76,0,0,0,0,4.75v2a.76.76,0,0,0,.75.75H6a.25.25,0,0,0,.25-.25V5.75A.25.25,0,0,1,6.5,5.5h1a.25.25,0,0,1,.25.25v1.5A.25.25,0,0,0,8,7.5h5.25A.76.76,0,0,0,14,6.75ZM9.78,1.88a.84.84,0,0,1,.7-.38.87.87,0,0,1,.28.05.85.85,0,0,1-.09,1.63l-1.44.31A.24.24,0,0,1,9,3.39a.26.26,0,0,1,0-.28ZM3.24,1.55a.87.87,0,0,1,.28-.05.84.84,0,0,1,.7.38L5,3.11a.26.26,0,0,1,0,.28.24.24,0,0,1-.25.1L3.33,3.18a.85.85,0,0,1-.09-1.63Z"
      ></path>
    </symbol>
    <symbol id="help-small" viewBox="0 0 14 14">
      <path
        d="M7,0a7,7,0,1,0,7,7A7.008,7.008,0,0,0,7,0ZM7,11.751a1,1,0,1,1,1-1A1,1,0,0,1,7,11.751Zm.917-3.908a.25.25,0,0,0-.167.236V8.25a.75.75,0,0,1-1.5,0v-1A.75.75,0,0,1,7,6.5,1.25,1.25,0,1,0,5.75,5.25a.75.75,0,0,1-1.5,0A2.75,2.75,0,1,1,7.917,7.843Z"
      ></path>
    </symbol>
    <symbol id="help-medium" viewBox="0 0 24 24">
      <path
        d="M1.000 12.001 A11.000 11.000 0 1 0 23.000 12.001 A11.000 11.000 0 1 0 1.000 12.001 Z"
      ></path>
      <path d="M12,17a.25.25,0,1,0,.25.25A.25.25,0,0,0,12,17h0"></path>
      <path d="M9,10.005a3,3,0,1,1,4.2,2.75A2,2,0,0,0,12,14.588V15"></path>
    </symbol>
    <symbol id="home-small" viewBox="0 0 14 14">
      <path
        d="M13,8a1,1,0,0,1-.71-.29L7,2.41,1.71,7.71A1,1,0,0,1,.29,6.29l6-6a1,1,0,0,1,1.42,0l6,6a1,1,0,0,1,0,1.42A1,1,0,0,1,13,8Z"
      ></path>
      <path
        d="M12,10a.47.47,0,0,0-.15-.35l-4.5-4.5a.48.48,0,0,0-.7,0l-4.5,4.5A.47.47,0,0,0,2,10v3.5a.5.5,0,0,0,.5.5H5.75A.25.25,0,0,0,6,13.75V11.5a1,1,0,0,1,2,0v2.25a.25.25,0,0,0,.25.25H11.5a.5.5,0,0,0,.5-.5Z"
      ></path>
    </symbol>
    <symbol id="link-left-small" viewBox="0 0 14 14">
      <use xlink:href="#link-right-small" transform="rotate(180 7 7)"></use>
    </symbol>
    <symbol id="link-right-small" viewBox="0 0 14 14">
      <g transform="matrix(0.5833333333333334,0,0,0.5833333333333334,0,0)">
        <path
          d="M23.987,12a2.411,2.411,0,0,0-.814-1.8L11.994.361a1.44,1.44,0,0,0-1.9,2.162l8.637,7.6a.25.25,0,0,1-.165.437H1.452a1.44,1.44,0,0,0,0,2.88H18.563a.251.251,0,0,1,.165.438l-8.637,7.6a1.44,1.44,0,1,0,1.9,2.161L23.172,13.8A2.409,2.409,0,0,0,23.987,12Z"
        ></path>
      </g>
    </symbol>
    <symbol id="log-in-medium" viewBox="0 0 24 24">
      <path
        d="M13.5 5V1.5C13.5 1.23478 13.3946 0.98043 13.2071 0.792893C13.0196 0.605357 12.7652 0.5 12.5 0.5H1.5C1.23478 0.5 0.98043 0.605357 0.792893 0.792893C0.605357 0.98043 0.5 1.23478 0.5 1.5V22.5C0.5 22.7652 0.605357 23.0196 0.792893 23.2071C0.98043 23.3946 1.23478 23.5 1.5 23.5H12.5C12.7652 23.5 13.0196 23.3946 13.2071 23.2071C13.3946 23.0196 13.5 22.7652 13.5 22.5V19"
      ></path>
      <path d="M4.5 12H23.5"></path>
      <path d="M9.5 7L4.5 12L9.5 17"></path>
    </symbol>
    <symbol id="log-out-medium" viewBox="0 0 24 24">
      <path
        d="M13.5 5V1.5C13.5 1.23478 13.3946 0.98043 13.2071 0.792893C13.0196 0.605357 12.7652 0.5 12.5 0.5H1.5C1.23478 0.5 0.98043 0.605357 0.792893 0.792893C0.605357 0.98043 0.5 1.23478 0.5 1.5V22.5C0.5 22.7652 0.605357 23.0196 0.792893 23.2071C0.98043 23.3946 1.23478 23.5 1.5 23.5H12.5C12.7652 23.5 13.0196 23.3946 13.2071 23.2071C13.3946 23.0196 13.5 22.7652 13.5 22.5V19"
      ></path>
      <path d="M23.5 12H4.5"></path>
      <path d="M18.5 17L23.5 12L18.5 7"></path>
    </symbol>
    <symbol id="menu-medium" viewBox="0 0 24 24">
      <rect x="0" y="4" width="24" height="1.5" rx="0.75"></rect>
      <rect x="0" y="11" width="24" height="1.5" rx="0.75"></rect>
      <rect x="0" y="18" width="24" height="1.5" rx="0.75"></rect>
    </symbol>
    <symbol id="negative-change-small" viewBox="0 0 14 14">
      <use
        xlink:href="#positive-change-small"
        transform="rotate(180 7 7)"
      ></use>
    </symbol>
    <symbol id="overflow-menu-small" viewBox="0 0 14 14">
      <circle cx="7" cy="2" r="2" />
      <circle cx="7" cy="7" r="2" />
      <circle cx="7" cy="12" r="2" />
    </symbol>
    <symbol id="pause-small" viewBox="0 0 14 14">
      <path
        d="M0.000 0.000 L5.000 0.000 L5.000 14.000 L-0.000 14.000 Z"
      ></path>
      <path
        d="M9.000 0.000 L14.000 0.000 L14.000 14.000 L9.000 14.000 Z"
      ></path>
    </symbol>
    <symbol id="play-small" viewBox="0 0 14 14">
      <path
        d="M13.126,5.605,2.241.163A1.54,1.54,0,0,0,.011,1.541V12.459a1.54,1.54,0,0,0,2.23,1.378L13.126,8.4a1.559,1.559,0,0,0,0-2.79Z"
      ></path>
    </symbol>
    <symbol id="play-medium" viewBox="0 0 24 24">
      <path
        d="M1.118,2.118a1,1,0,0,1,1.447-.894l19.764,9.882a1,1,0,0,1,0,1.788L2.565,22.776a1,1,0,0,1-1.447-.894Z"
      ></path>
    </symbol>
    <symbol id="plus-small" viewBox="0 0 14 14">
      <g transform="matrix(0.5833333333333334,0,0,0.5833333333333334,0,0)">
        <path
          d="M0,12a1.5,1.5,0,0,0,1.5,1.5h8.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3H13.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v8.75a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,12Z"
        ></path>
      </g>
    </symbol>
    <symbol id="pop-window-small" viewBox="0 0 14 14">
      <path
        d="M12.75,0H3.25A1.25,1.25,0,0,0,2,1.25v1.5a.76.76,0,0,0,.75.75h9.5a.25.25,0,0,1,.25.25v5.5a.25.25,0,0,1-.25.25h-.5a.75.75,0,0,0,0,1.5h1A1.25,1.25,0,0,0,14,9.75V1.25A1.25,1.25,0,0,0,12.75,0Z"
      ></path>
      <path
        d="M9.5,6.25A1.25,1.25,0,0,0,8.25,5h-7A1.25,1.25,0,0,0,0,6.25v6.5A1.25,1.25,0,0,0,1.25,14h7A1.25,1.25,0,0,0,9.5,12.75ZM1.75,12.5a.25.25,0,0,1-.25-.25V8.75a.25.25,0,0,1,.25-.25h6A.25.25,0,0,1,8,8.75v3.5a.25.25,0,0,1-.25.25Z"
      ></path>
    </symbol>
    <symbol id="positive-change-small" viewBox="0 0 14 14">
      <path
        d="M11.207,3.793l-3.5-3.5a1,1,0,0,0-1.414,0l-3.5,3.5A1,1,0,0,0,4.207,5.207L5.573,3.841A.25.25,0,0,1,6,4.018V13a1,1,0,0,0,2,0V4.018a.25.25,0,0,1,.427-.177L9.793,5.207a1,1,0,0,0,1.414-1.414Z"
      ></path>
    </symbol>
    <symbol id="print-small" viewBox="0 0 14 14">
      <path
        d="M14,5.25A1.252,1.252,0,0,0,12.75,4H11V.75A.75.75,0,0,0,10.25,0H3.75A.75.75,0,0,0,3,.75V4H1.25A1.252,1.252,0,0,0,0,5.25v3.5A1.252,1.252,0,0,0,1.25,10H3v3.25a.75.75,0,0,0,.75.75h6.5a.75.75,0,0,0,.75-.75V10h1.75A1.252,1.252,0,0,0,14,8.75Zm-4.5,7a.25.25,0,0,1-.25.25H4.75a.25.25,0,0,1-.25-.25v-2A.25.25,0,0,1,4.75,10h4.5a.25.25,0,0,1,.25.25Zm0-7a.25.25,0,0,1-.25.25H4.75a.25.25,0,0,1-.25-.25V1.75a.25.25,0,0,1,.25-.25h4.5a.25.25,0,0,1,.25.25ZM12,8.5H10.5a.5.5,0,0,1,0-1H12a.5.5,0,0,1,0,1Z"
      ></path>
    </symbol>
    <symbol id="print-medium" viewBox="0 0 24 24">
      <line x1="7.5" y1="19.499" x2="16.5" y2="19.499"></line>
      <line x1="7.5" y1="16.499" x2="16.5" y2="16.499"></line>
      <path
        d="M5.5,16.5h-3a2.006,2.006,0,0,1-2-2v-6a2.006,2.006,0,0,1,2-2h19a2.006,2.006,0,0,1,2,2v6a2.006,2.006,0,0,1-2,2h-3"
      ></path>
      <path
        d="M5.5,4.5V.5h9.586a1,1,0,0,1,.707.293l2.414,2.414a1,1,0,0,1,.293.707V4.5"
      ></path>
      <path d="M18.5,22.5a1,1,0,0,1-1,1H6.5a1,1,0,0,1-1-1v-9h13Z"></path>
      <circle cx="3.5" cy="9.499" r="1"></circle>
      <polyline points="14.5 0.499 14.5 4.499 18.5 4.499"></polyline>
    </symbol>
    <symbol id="refresh-small" viewBox="0 0 14 14">
      <path
        d="M13.978,10.183,13.5,8.26a.751.751,0,0,0-.91-.545l-1.922.48a.75.75,0,0,0-.2,1.371l.615.369A5.564,5.564,0,0,1,7,12.019,5.047,5.047,0,0,1,2.284,8.713a.75.75,0,0,0-1.409.516A6.552,6.552,0,0,0,7,13.519a7.063,7.063,0,0,0,5.375-2.8l.489.293a.75.75,0,0,0,1.114-.825Z"
      ></path>
      <path
        d="M1.413,6.285l1.922-.48A.75.75,0,0,0,3.54,4.434l-.567-.34A5.593,5.593,0,0,1,7,1.981a5.047,5.047,0,0,1,4.716,3.306.75.75,0,0,0,1.409-.516A6.552,6.552,0,0,0,7,.481,7.141,7.141,0,0,0,1.672,3.314l-.536-.322a.75.75,0,0,0-1.114.825L.5,5.74a.751.751,0,0,0,.727.568A.765.765,0,0,0,1.413,6.285Z"
      ></path>
    </symbol>
    <symbol id="remove-small" viewBox="0 0 14 14">
      <path
        d="M8.591,7.177a.25.25,0,0,1,0-.354l4.616-4.616A1,1,0,1,0,11.793.793L7.177,5.409a.25.25,0,0,1-.354,0L2.207.793A1,1,0,0,0,.793,2.207L5.409,6.823a.25.25,0,0,1,0,.354L.793,11.793a1,1,0,0,0,1.414,1.414L6.823,8.591a.25.25,0,0,1,.354,0l4.616,4.616a1,1,0,0,0,1.414-1.414Z"
      ></path>
    </symbol>
    <symbol id="remove-medium" viewBox="0 0 24 24">
      <line class="st0" x1="7" y1="7" x2="17" y2="17"></line>
      <line class="st0" x1="17" y1="7" x2="7" y2="17"></line>
    </symbol>
    <symbol id="revert-small" viewBox="0 0 14 14">
      <path
        d="M5.917 1.609a5.499 5.499 0 1 1-3.71 2.695l.93.557a.75.75 0 0 0 1.113-.825l-.555-2.218a.75.75 0 0 0-.91-.546l-2.217.555a.75.75 0 0 0-.204 1.37l.557.335A6.999 6.999 0 1 0 5.62.138a.75.75 0 0 0 .296 1.47ZM7 2.75a.75.75 0 0 1 .75.75v3.575l2.136 1.282a.75.75 0 1 1-.772 1.286l-2.5-1.5A.75.75 0 0 1 6.25 7.5v-4A.75.75 0 0 1 7 2.75Z"
      />
    </symbol>
    <symbol id="rewind-small" viewBox="0 0 14 14">
      <use
        xlink:href="#fast-forward-small"
        transform="rotate(180 7 7)"
      ></use>
    </symbol>
    <symbol id="search-small" viewBox="0 0 14 14">
      <path
        d="M13.7265333,13.7265333 C14.0908898,13.3620668 14.0908898,12.7712665 13.7265333,12.4068 L11.2336,9.91386667 C11.1540898,9.83623848 11.1400548,9.71343261 11.2,9.61986667 C12.7859562,7.21942761 12.2968024,4.00803252 10.0680889,2.18863689 C7.83937529,0.369241252 4.59506283,0.532845819 2.56068766,2.56722099 C0.526312486,4.60159616 0.362707918,7.84590863 2.18210355,10.0746222 C4.00149919,12.3033358 7.21289428,12.7924895 9.61333333,11.2065333 C9.70604473,11.1456273 9.82876411,11.158094 9.90733333,11.2364 L12.4002667,13.7293333 C12.575925,13.9059433 12.8148922,14.0050094 13.0639838,14.0044856 C13.3130755,14.0039576 13.5516222,13.9038834 13.7265333,13.7265333 Z M2.8,6.53333333 C2.8,4.47147027 4.47147027,2.8 6.53333333,2.8 C8.5951964,2.8 10.2666667,4.47147027 10.2666667,6.53333333 C10.2666667,8.5951964 8.5951964,10.2666667 6.53333333,10.2666667 C5.54319177,10.2666667 4.59360383,9.87333446 3.89346802,9.17319865 C3.1933322,8.47306284 2.8,7.5234749 2.8,6.53333333 Z"
      ></path>
    </symbol>
    <symbol id="search-medium" viewBox="0 0 24 24">
      <path
        d="M0.500 10.500 A10.000 10.000 0 1 0 20.500 10.500 A10.000 10.000 0 1 0 0.500 10.500 Z"
      ></path>
      <path d="M23.5 23.5L17.571 17.571"></path>
    </symbol>
    <symbol id="settings-small" viewBox="0 0 14 14">
      <path
        d="M12.44,8a.23.23,0,0,1-.06-.16V6.19A.23.23,0,0,1,12.44,6l.75-.94a1.07,1.07,0,0,0,.09-1.21l-.44-.76a1.09,1.09,0,0,0-1.09-.53l-1.19.18a.22.22,0,0,1-.16,0L9,1.93a.24.24,0,0,1-.11-.13L8.44.68a1.07,1.07,0,0,0-1-.68H6.56a1.07,1.07,0,0,0-1,.68L5.12,1.8A.24.24,0,0,1,5,1.93L3.6,2.74a.22.22,0,0,1-.16,0L2.25,2.59a1.09,1.09,0,0,0-1.09.53l-.44.76A1.07,1.07,0,0,0,.81,5.09L1.56,6a.23.23,0,0,1,.06.16V7.81A.23.23,0,0,1,1.56,8l-.75.94a1.07,1.07,0,0,0-.09,1.21l.44.76a1.09,1.09,0,0,0,1.09.53l1.19-.18a.22.22,0,0,1,.16,0L5,12.07a.24.24,0,0,1,.11.13l.44,1.12a1.07,1.07,0,0,0,1,.68h.88a1.07,1.07,0,0,0,1-.68l.44-1.12A.24.24,0,0,1,9,12.07l1.41-.81a.22.22,0,0,1,.16,0l1.19.18a1.09,1.09,0,0,0,1.09-.53l.44-.76a1.07,1.07,0,0,0-.09-1.21ZM7,9.25A2.25,2.25,0,1,1,9.25,7,2.25,2.25,0,0,1,7,9.25Z"
      ></path>
    </symbol>
    <symbol id="share-small" viewBox="0 0 14 14">
      <path
        d="M14,11.25A2.748,2.748,0,0,0,9.317,9.3a.251.251,0,0,1-.288.046L5.61,7.633a.251.251,0,0,1-.136-.258,2.692,2.692,0,0,0,0-.75.251.251,0,0,1,.136-.258L9.029,4.658a.249.249,0,0,1,.288.046,2.751,2.751,0,1,0-.8-1.651.25.25,0,0,1-.137.252L4.914,5.038A.249.249,0,0,1,4.631,5,2.75,2.75,0,1,0,4.631,9a.251.251,0,0,1,.283-.042L8.38,10.7a.249.249,0,0,1,.137.251,2.75,2.75,0,1,0,5.483.3Z"
      ></path>
    </symbol>
    <symbol id="subtract-small" viewBox="0 0 14 14">
      <g transform="matrix(0.5833333333333334,0,0,0.5833333333333334,0,0)">
        <path
          d="M1.5,13.5h21a1.5,1.5,0,0,0,0-3H1.5a1.5,1.5,0,0,0,0,3Z"
        ></path>
      </g>
    </symbol>
    <symbol id="success-small" viewBox="0 0 14 14">
      <path
        d="M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0Zm3.6,5.9-4,4a1,1,0,0,1-.7.3,1,1,0,0,1-.71-.3L3.4,8.07A1,1,0,0,1,4.82,6.65l.92.93a.29.29,0,0,0,.18.07.26.26,0,0,0,.17-.07L9.18,4.49a1,1,0,0,1,1.42,0A1,1,0,0,1,10.6,5.9Z"
      ></path>
    </symbol>
    <symbol id="success-medium" viewBox="0 0 24 24">
      <use xlink:href="#check-medium"></use>
      <path
        d="M0.500 11.999 A11.500 11.500 0 1 0 23.500 11.999 A11.500 11.500 0 1 0 0.500 11.999 Z"
      ></path>
    </symbol>
    <symbol id="success-fill-medium" viewBox="0 0 24 24">
      <path
        d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm6.93,8.2-6.85,9.29a1,1,0,0,1-1.43.19L5.76,13.77a1,1,0,0,1-.15-1.41A1,1,0,0,1,7,12.21l4.08,3.26L17.32,7a1,1,0,0,1,1.39-.21A1,1,0,0,1,18.93,8.2Z"
      ></path>
    </symbol>
    <symbol id="time-small" viewBox="0 0 14 14">
      <path
        d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM7.625 4.5C7.625 4.15482 7.34518 3.875 7 3.875C6.65482 3.875 6.375 4.15482 6.375 4.5V7C6.375 7.14621 6.42626 7.28779 6.51986 7.40012L9.01986 10.4001C9.24084 10.6653 9.63494 10.7011 9.90012 10.4801C10.1653 10.2592 10.2011 9.86506 9.98014 9.59988L7.625 6.77372V4.5Z"
      ></path>
    </symbol>
    <symbol id="transact-small" viewBox="0 0 14 14">
      <g transform="matrix(0.5833333333333334,0,0,0.5833333333333334,0,0)">
        <path
          d="M10.37 19.31a1.53 1.53 0 0 0 1.06 0.44 1.49 1.49 0 0 0 1.06 -0.44l7.15 -7.15a0.25 0.25 0 0 1 0.36 0l0.88 0.89a1 1 0 0 0 1.68 -0.47L24 6.93a1 1 0 0 0 -0.29 -0.93 1 1 0 0 0 -0.95 -0.27l-5.66 1.4a1 1 0 0 0 -0.72 0.7 1 1 0 0 0 0.26 1l0.88 0.89a0.22 0.22 0 0 1 0.07 0.17 0.24 0.24 0 0 1 -0.07 0.18l-7.15 7.15a1.51 1.51 0 0 0 0 2.09Z"
        ></path>
        <path
          d="m11.54 4.66 -7.39 7a0.25 0.25 0 0 1 -0.35 0L3.12 11a1 1 0 0 0 -1.68 0.47L0 17.07a1 1 0 0 0 0.29 0.93 1 1 0 0 0 1 0.27l5.61 -1.4a1 1 0 0 0 0.46 -1.68L6.27 14.1a0.27 0.27 0 0 1 -0.07 -0.18 0.23 0.23 0 0 1 0.08 -0.17l7.32 -6.91a1.5 1.5 0 0 0 -2.06 -2.18Z"
        ></path>
      </g>
    </symbol>
    <symbol id="trash-small" viewBox="0 0 14 14">
      <g transform="matrix(1.4,0,0,1.4,0,0)">
        <path
          d="M10,2.942a.75.75,0,0,0-.75-.75H7.562a.25.25,0,0,1-.245-.2,2.381,2.381,0,0,0-4.675,0,.251.251,0,0,1-.245.2H.75a.75.75,0,0,0,0,1.5H1a.25.25,0,0,1,.25.25v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5a1.5,1.5,0,0,0,1.5-1.5v-4.5A.25.25,0,0,1,9,3.692h.25A.75.75,0,0,0,10,2.942ZM4.979,1.312A1.108,1.108,0,0,1,5.9,1.8a.254.254,0,0,1,.015.259.25.25,0,0,1-.221.133H4.269A.25.25,0,0,1,4.063,1.8,1.1,1.1,0,0,1,4.979,1.312ZM4.125,7.688a.625.625,0,0,1-1.25,0v-2.5a.625.625,0,1,1,1.25,0Zm3,0a.625.625,0,0,1-1.25,0v-2.5a.625.625,0,1,1,1.25,0Z"
        ></path>
      </g>
    </symbol>
    <symbol id="upload-small" viewBox="0 0 14 14">
      <path
        d="M4,3.78A.75.75,0,0,0,5,3.78L5.82,3a.26.26,0,0,1,.28-.06.25.25,0,0,1,.15.23V8.25a.75.75,0,0,0,1.5,0V3.16a.25.25,0,0,1,.15-.23A.26.26,0,0,1,8.18,3L9,3.78a.75.75,0,0,0,1.06,0,.75.75,0,0,0,0-1.06L7.53.22a.75.75,0,0,0-1.06,0L4,2.72A.75.75,0,0,0,4,3.78Z"
      ></path>
      <path
        d="M13,9.5a1,1,0,0,0-1,1v1.25a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,11.75V10.5a1,1,0,0,0-2,0V12a2,2,0,0,0,2,2H12a2,2,0,0,0,2-2V10.5A1,1,0,0,0,13,9.5Z"
      ></path>
    </symbol>
    <symbol id="upload-medium" viewBox="0 0 24 24">
      <path
        d="M23,18.218v1.913A2.87,2.87,0,0,1,20.131,23H3.869A2.869,2.869,0,0,1,1,20.131V18.218"
      ></path>
      <path d="M12 1L12 18.108"></path>
      <path d="M5 8L12 1 19 8"></path>
    </symbol>
    <symbol id="user-medium" viewBox="0 0 24 24">
      <path
        d="M0.500 12.000 A11.500 11.500 0 1 0 23.500 12.000 A11.500 11.500 0 1 0 0.500 12.000 Z"
      ></path>
      <path
        d="M3.959,20.221a25.59,25.59,0,0,1,5.413-2.352c.837-.309.928-2.229.328-2.889-.866-.953-1.6-2.07-1.6-4.766A3.812,3.812,0,0,1,12,6.047a3.812,3.812,0,0,1,3.9,4.167c0,2.7-.734,3.813-1.6,4.766-.6.66-.509,2.58.328,2.889a25.59,25.59,0,0,1,5.413,2.352"
      ></path>
    </symbol>
    <symbol id="view-grid-medium" viewBox="0 0 24 24">
      <path
        d="M10.5,9.5a1,1,0,0,1-1,1h-8a1,1,0,0,1-1-1v-8a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1Z"
      ></path>
      <path
        d="M23.5,9.5a1,1,0,0,1-1,1h-8a1,1,0,0,1-1-1v-8a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1Z"
      ></path>
      <path
        d="M10.5,22.5a1,1,0,0,1-1,1h-8a1,1,0,0,1-1-1v-8a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1Z"
      ></path>
      <path
        d="M23.5,22.5a1,1,0,0,1-1,1h-8a1,1,0,0,1-1-1v-8a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1Z"
      ></path>
    </symbol>
    <symbol id="view-list-medium" viewBox="0 0 24 24">
      <line x1="8.5" y1="4.5" x2="23.5" y2="4.5"></line>
      <line x1="8.5" y1="12.5" x2="23.5" y2="12.5"></line>
      <line x1="8.5" y1="20.5" x2="23.5" y2="20.5"></line>
      <rect x="0.5" y="2.5" width="4" height="4" rx="1" ry="1"></rect>
      <rect x="0.5" y="10.5" width="4" height="4" rx="1" ry="1"></rect>
      <rect x="0.5" y="18.5" width="4" height="4" rx="1" ry="1"></rect>
    </symbol>
    <symbol id="volume-off-small" viewBox="0 0 14 14">
      <path
        d="M6.41,10.78a.25.25,0,0,0,0,.34l2.16,2.41a1.35,1.35,0,0,0,.8.27,1.31,1.31,0,0,0,1.31-1.31V7.12a.26.26,0,0,0-.43-.18Z"
      ></path>
      <path
        d="M.26,13.81h0a.76.76,0,0,0,1,0l12.5-12.5A.76.76,0,0,0,13.94,1,.71.71,0,0,0,14,.76a.73.73,0,0,0-.19-.49l0,0a.74.74,0,0,0-1.06,0l-2,2a.26.26,0,0,1-.19.07.25.25,0,0,1-.18-.08,1.23,1.23,0,0,0-1-.45,1.29,1.29,0,0,0-.8.27L5.74,5.21a.23.23,0,0,1-.19.09H4.42A1.75,1.75,0,0,0,2.67,7.05v1.5A1.78,1.78,0,0,0,3,9.61a.25.25,0,0,1,0,.33L.22,12.73a.75.75,0,0,0,0,1.06Z"
      ></path>
    </symbol>
    <symbol id="volume-on-small" viewBox="0 0 14 14">
      <path
        d="M12,2.21a.75.75,0,0,0-1.06,0,.75.75,0,0,0,0,1.06,5.26,5.26,0,0,1,0,7.46.75.75,0,0,0,0,1.06.75.75,0,0,0,1.06,0,6.74,6.74,0,0,0,0-9.58Z"
      ></path>
      <path
        d="M10.34,4.89a.75.75,0,0,0-1.23.85,2.23,2.23,0,0,1,0,2.52.74.74,0,0,0,.19,1,.75.75,0,0,0,1-.19,3.7,3.7,0,0,0,0-4.22Z"
      ></path>
      <path
        d="M6.69,1a1.35,1.35,0,0,0-.8.27L3.07,4.42a.27.27,0,0,1-.19.08H1.75A1.76,1.76,0,0,0,0,6.25v1.5A1.76,1.76,0,0,0,1.75,9.5H2.88a.27.27,0,0,1,.19.08l2.82,3.15a1.35,1.35,0,0,0,.8.27A1.31,1.31,0,0,0,8,11.69V2.31A1.31,1.31,0,0,0,6.69,1Z"
      ></path>
    </symbol>
    <symbol id="warning-small" viewBox="0 0 14 14">
      <path
        d="M13.84,11.83,8.34.83a1.5,1.5,0,0,0-2.68,0l-5.5,11a1.49,1.49,0,0,0,.06,1.46A1.52,1.52,0,0,0,1.5,14h11a1.52,1.52,0,0,0,1.28-.71A1.49,1.49,0,0,0,13.84,11.83ZM6.25,5a.75.75,0,0,1,1.5,0V8a.75.75,0,0,1-1.5,0ZM7,12a1,1,0,1,1,1-1A1,1,0,0,1,7,12Z"
      ></path>
    </symbol>
    <symbol id="warning-medium" viewBox="0 0 24 24">
      <path
        d="M22.553,22.581a.569.569,0,0,1-.553.894H2a.569.569,0,0,1-.553-.894L11.553,2.37c.246-.492.648-.492.894,0Z"
      ></path>
      <path d="M12 16.979L12 9.979"></path>
      <path
        d="M11.991,18.979a.246.246,0,0,0-.241.255.255.255,0,0,0,.254.245h.005a.246.246,0,0,0,.241-.255A.255.255,0,0,0,12,18.979h-.005"
      ></path>
    </symbol>
    <symbol id="warning-fill-medium" viewBox="0 0 24 24">
      <use xlink:href="#warning-small"></use>
    </symbol>
  </svg>
</div>

<c11n-button
  ngClass="button"
  buttonType="submit"
  [labelText]="'Add to Watchlist'"
  [variant]="'primary'"
  [fullWidth]="false"
  (clickEvent)="openCheckbox()"
  *ngIf="widsWithFund.length === 0"
>
</c11n-button>
<c11n-button
  ngClass="button"
  buttonType="submit"
  [labelText]="'Watching'"
  [iconName]="'success'"
  [iconPosition]="'leading'"
  [variant]="'primary'"
  [fullWidth]="false"
  (clickEvent)="openCheckbox()"
  *ngIf="widsWithFund.length > 0"
>
</c11n-button>
<c11n-modal-dialog-entrypoint></c11n-modal-dialog-entrypoint>

<c11n-modal-dialog
  #modalCheckbox
  [headingText]="title"
  [hideBody]="false"
  [hasForm]="true"
  (closeEvent)="cancel()"
>
  <div
    c11n-modal-dialog-body
    class="modal-checkbox"
  >
    <div *ngIf="!errorOnSaveChanges">
      <div class="chip-warming-wl" *ngIf="chipTrue">
        <c11n-icon
          ngClass="icon"
          [name]="'success'"
          [size]="'small'"
          [scale]="'larger'"
        ></c11n-icon>
        <p>{{chipAddWatchlistText}}</p>
      </div>
      <div *ngIf="watchlists.length >= 6" id="max-wl">
        <p class="c11n-text-sm min-text-addwl">
          You've reached the maximum number of watchlists. If you'd like to
          delete a watchlist.
          <a c11n-link [href]="linkWatchlist" onclick="redirectToWatchlistPage()"
            >go to the watchlist page</a
          >
        </p>
      </div>
      <c11n-checkbox-group
        ngClass="checkbox-div"
        [groupId]="'checkboxId'"
        [isDisabled]="false"
        [hideLegend]="true"
        *ngIf="watchlists.length > 0"
      >
        <c11n-checkbox
          *ngFor="let watchlist of watchlists"
          [focusLabel]="true"
          [isIndeterminate]="false"
          [labelText]="watchlist.title"
          [isDisabled]="false"
          [hideLabel]="false"
          [variant]="'tile'"
          [descriptiveLabel]="' '"
        >
          <input
            c11nCheckboxInput
            class="c11n-checkbox__input"
            [id]="watchlist.wid"
            type="checkbox"
            name="wls"
            [value]="watchlist.wid"
            [checked]="widsWithFund.includes(watchlist.wid)"
            (click)="addRemoveWatchlist(watchlist.wid)"
          />
        </c11n-checkbox>
      </c11n-checkbox-group>
    </div>

    <c11n-banner
      [hasCloseControl]="false"
      [closeAriaLabel]="'close button'"
      [headingText]="'Something went wrong.'"
      [variant]="'error'"
      *ngIf="errorOnSaveChanges"
    >
      <div class="c11n-text-md--crop">
        Please close and try again later.
      </div>
    </c11n-banner>
  </div>
  <div c11n-modal-dialog-custom-buttons class="footer">
    <div class="c11n-text-md create-wl-div" *ngIf="watchlists.length < 6">
      <c11n-icon
        ngClass="'target'"
        [name]="'plus'"
        [size]="'small'"
        [scale]="'normal'"
      ></c11n-icon>
      <a c11n-link class="trigger" (click)="openModalCreateWl()"
        >Create a new watchlist</a
      >
    </div>
    <div class="btns">
      <c11n-button
        *ngIf="!errorOnSaveChanges"
        ngClass="button"
        buttonType="submit"
        [labelText]="'Save'"
        [variant]="'primary'"
        [fullWidth]="true"
        (clickEvent)="saveWatchlistChanges()"
        [disabled]="widsWithFund.length === 0"
        data-btn="dialog-content-button"
      ></c11n-button>
      <c11n-button
        *ngIf="!errorOnSaveChanges"
        ngClass="button"
        buttonType="submit"
        [labelText]="'Cancel'"
        [variant]="'secondary'"
        [fullWidth]="true"
        data-btn="dialog-content-button"
        (clickEvent)="cancel()"
      ></c11n-button>
      <c11n-button
        *ngIf="errorOnSaveChanges"
        ngClass="button"
        buttonType="submit"
        [labelText]="'Close'"
        [variant]="'primary'"
        [fullWidth]="true"
        data-btn="dialog-content-button"
        (clickEvent)="cancel()"
      ></c11n-button>
    </div>

    <c11n-hint-error
      [hasError]="nothingChecked"
      [errorText]="errorMessageOnNothingChecked"
    ></c11n-hint-error>
  </div>
</c11n-modal-dialog>

<c11n-modal-dialog
  #modalEmptyWatchlist
  [headingText]="title"
  [hideBody]="false"
>
  <div
    c11n-modal-dialog-body
    [ngClass]="
      'dialog-example-content-width dialog-example-content-width--flex'
    "
    class="modal-empty-body"
  >
    <div class="c11n-text-md create-wl-div">
      <c11n-icon
        ngClass="'target'"
        [name]="'plus'"
        [size]="'small'"
        [scale]="'normal'"
      ></c11n-icon>
      <a c11n-link class="trigger" (click)="openModalCreateWl()"
        >Create a new watchlist</a
      >
    </div>
  </div>
</c11n-modal-dialog>

<c11n-modal-dialog
  #modalSuccess
  [headingText]="'Your watchlist has been updated.'"
  [hideBody]="false"
  [variant]="'success'"
  (closeEvent)="cancel()"
>
  <div
    c11n-modal-dialog-body
    [ngClass]="
      'dialog-example-content-width dialog-example-content-width--flex'
    "
  >
    <div class="c11n-text-md go-to-wl">
      <a
        c11n-link
        [href]="linkWatchlist"
        onclick="redirectToWatchlistPage()"
        [variant]="'secondary-independent'"
        [iconName]="'link-right'"
        [iconPosition]="'trailing'"
        [noWrap]="true"
        >Go to Watchlist</a
      >
    </div>
  </div>
</c11n-modal-dialog>

<c11n-modal-dialog
  #generalError
  [headingText]="'Something went wrong.'"
  [hideBody]="false"
  [variant]="'error'"
  [ngClass]="'modal-error'"
>
  <div
    c11n-modal-dialog-body
    [ngClass]="
      'dialog-example-content-width dialog-example-content-width--flex'
    "
  >
    <p>Please refresh the page or try again later.</p>
  </div>
</c11n-modal-dialog>

<c11n-modal-dialog
  #modalCreateWl
  [headingText]="'Create a new watchlist'"
  [hideBody]="false"
  [hasForm]="true"
  (closeEvent)="cancel()"
>
  <div
    c11n-modal-dialog-body
    [ngClass]="
      'dialog-example-content-width dialog-example-content-width--flex'
    "
    class="modal-createWl"
  >
    <div *ngIf="!errorOnCreateWatchlistSave">
      <label c11n-label [for]="'createWlName'" [size]="'medium'">
        Watchlist name
      </label>
      <c11n-input [size]="'medium'" [hasError]="false">
        <input
          c11nInput
          type="text"
          id="createWlName"
          name="info"
          [placeholder]="'Enter watchlist name'"
          aria-describedby="createWlName-description"
          (keyup)="checkCreateWatchlistsLength($event)"
          [(ngModel)]="newWatchlistName"
        />
      </c11n-input>
      <c11n-hint-error
        [hasError]="errorOnCreateWatchlist"
        [hintText]="newWatchlistName.length + '/50 characters (1 character minimum)'"
        [errorText]="errorOnCreateWatchlistMessage"
        [size]="'medium'"
        [hintErrorId]="'createWlName-description'"
      ></c11n-hint-error>
    </div>
    <c11n-banner
      [hasCloseControl]="false"
      [closeAriaLabel]="'close button'"
      [headingText]="'Something went wrong.'"
      [variant]="'error'"
      *ngIf="errorOnCreateWatchlistSave"
    >
      <div class="c11n-text-md--crop">
        Please close and try again later.
      </div>
    </c11n-banner>
  </div>
  <div c11n-modal-dialog-custom-buttons class="footer" id="footer-create-wl">
    <div class="btns">
      <c11n-button
      ngClass="button"
      *ngIf="!errorOnCreateWatchlistSave"
      buttonType="submit"
      [labelText]="'Create'"
      [variant]="'primary'"
      [fullWidth]="true"
      (clickEvent)="createWatchlist()"
      data-btn="dialog-content-button"
      ></c11n-button>
      <c11n-button
        ngClass="button"
        *ngIf="!errorOnCreateWatchlistSave"
        buttonType="submit"
        [labelText]="'Cancel'"
        [variant]="'secondary'"
        [fullWidth]="true"
        data-btn="dialog-content-button"
        (clickEvent)="cancel()"
      ></c11n-button>
      <c11n-button
        *ngIf="errorOnCreateWatchlistSave"
        ngClass="button"
        buttonType="submit"
        [labelText]="'Close'"
        [variant]="'primary'"
        [fullWidth]="true"
        data-btn="dialog-content-button"
        (clickEvent)="cancel()"
      ></c11n-button>
    </div>
  </div>
</c11n-modal-dialog>
